import $ from 'jquery'

SOPHIA.CreditTransfer = function($container) {
  this.$container          = $container;
  this.$creditTransferForm = $('#credit_transfer_form', this.$container);
  this.$transferOverlay    = $('.credit-transfer-modal', this.$container);
  this.$openModalLink      = $('.show-credit-transfer-overlay', this.$container);
  this.$universitiesModal  = $('.credit-transfer-universities-modal', this.$container);
  this.$universitiesLink   = $('.credit-transfer-universities-link', this.$container);

  this.init();
}

SOPHIA.CreditTransfer.prototype = {
  init: function() {
    var context = this;
    this.$creditTransferForm.on('submit', function(e) {
      context.submitCreditTransfer(e, context);
    });

    this.$openModalLink.on('click', function(e) {
      e.preventDefault();
      context.showTransferOverlay($(this));
    });

    this.$universitiesLink.on('click', function(e) {
      e.preventDefault();
      context.showUniversitiesModal({ back: $(this).data('back') });
    });
  },

  showTransferOverlay: function(focus) {
    SOPHIA.overlayBox(this.$transferOverlay, {
      margin: 0,
      padding: 0,
      showCloseButton: true,
      doNotFocus: true
    }, focus);
  },

  xhrData: function() {
    return {
      url: this.$creditTransferForm.attr('action'),
      type: 'post',
      dataType: 'json',
      data: this.$creditTransferForm.serialize()
    }
  },

  showErrors: function(allErrors) {
    $.each(allErrors, function(key, errors) {
      var $field = $("#credit_transfer_" + key, this.$creditTransferForm).parents('.credit-transfer-modal__field');

      var i;

      for ( i = 0; i < errors.length; i++ ) {
        $field.append("<p class = 'inline-errors'>" + errors[i] + "</p>");
      }
    });
  },

  callbacks: function() {
    var context = this;
    return {
      afterSuccess: function(response) {
        if ( response.success ) {
          SOPHIA.closeOverlayBox();
          SOPHIA.flashMessage( "Got it, thanks! We've put Transferman on the job!", 'success' );
          context.$creditTransferForm[0].reset();
        } else {
          context.showErrors(response.errors);
        }
      }
    };
  },

  submitCreditTransfer: function(e, context) {
    e.preventDefault();
    $('.inline-errors', this.$creditTransferForm).remove();
    SOPHIA.sendXHR(context.xhrData(), context.callbacks());
  },

  showUniversitiesModal: function() {
    SOPHIA.overlayBox(this.$universitiesModal);
  }
}
